// Each module in this file should be considered independent of
// templates or individual routes. Instead, each module should be
// dynamically imported based on a test criteria such as the
// presence of a DOM element with a given data attribute.

// This file is loaded globally but should just contain dynamically
// loaded module logic only.

// --------------------------------
// Import and execute the global JS
// --------------------------------

if (true) {
	import('./main')
	.then(({ mainJs }) => {
		mainJs()
	})
}

// --------------------------------
// Heading text animation
// --------------------------------
const bloomingTextElements = document.querySelectorAll('[data-animation="bloomingText"]')

if (bloomingTextElements.length > 0) {
	import('./animation/blooming-text')
			.then(({ bloomingText }) => {
				bloomingTextElements.forEach(element => {
					bloomingText(element)
				})
			})
}

// --------------------------------
// Fade in and up animation when in viewport
// --------------------------------
const fadeInUpElements = document.querySelectorAll('[data-animation="fadeInUp"]')

if (fadeInUpElements.length > 0) {
  import('./animation/fade-in-up')
    .then(({ fadeInUp }) => {
			fadeInUpElements.forEach(element => {
				fadeInUp(element)
			})
		})
}

const underlineElements = document.querySelectorAll('[data-module="underline"]')

if (underlineElements.length > 0) {
	import('./animation/underline')
			.then(({ underline }) => {
				underlineElements.forEach(element => {
					underline(element)
				})
			})
}

const keyFactsElements = document.querySelectorAll('[data-module="key-facts"]')

if (keyFactsElements.length > 0) {
	import('./animation/key-facts')
			.then(({ keyFacts }) => {
				keyFactsElements.forEach(element => {
					keyFacts(element)
				})
			})
}

const sustainabilityElements = document.querySelectorAll('[data-module="sustainability"]')

if (sustainabilityElements.length > 0) {
	import('./animation/sustainability')
			.then(({ sustainability }) => {
				sustainabilityElements.forEach(element => {
					sustainability(element)
				})
			})
}

const testimonialsElements = document.querySelectorAll('[data-module="testimonials"]')

if (testimonialsElements.length > 0) {
	import('./animation/testimonials')
			.then(({ testimonials }) => {
				testimonialsElements.forEach(element => {
					testimonials(element)
				})
			})
}

const newsElements = document.querySelectorAll('[data-module="news"]')

if (newsElements.length > 0) {
	import('./animation/news')
			.then(({ news }) => {
				newsElements.forEach(element => {
					news(element)
				})
			})
}

const valuesElements = document.querySelectorAll('[data-module="values"]')

if (valuesElements.length > 0) {
	import('./animation/values')
			.then(({ values }) => {
				valuesElements.forEach(element => {
					values(element)
				})
			})
}

// --------------------------------
// Animate cards on scroll within a grid
// --------------------------------
// const grids = document.querySelectorAll('[data-animation="grid-cards"]')
//
// if (grids.length > 0) {
//   import('./animation/grid-cards')
//     .then(({ gridCards }) => {
// 			grids.forEach(grid => {
// 				gridCards(grid)
// 			})
// 		})
// }

// --------------------------------
// Filtering
// --------------------------------
const filtersContainers = document.querySelectorAll('[data-module="filters"]')

if (filtersContainers.length > 0) {
  import('./components/filters')
    .then(({ filters }) => {
			filtersContainers.forEach(container => {
				filters(container)
			})
		})
}

const postFiltersContainers = document.querySelectorAll('[data-module="post-filters"]')

if (postFiltersContainers.length > 0) {
	import('./components/post-filters')
			.then(({ postFilters }) => {
				postFiltersContainers.forEach(container => {
					postFilters(container)
				})
			})
}


// --------------------------------
// Team
// --------------------------------
const teamContainers = document.querySelectorAll('[data-module="team"]')

if (teamContainers.length > 0) {
	import('./components/team')
			.then(({ team }) => {
				teamContainers.forEach(container => {
					team(container)
				})
			})
}

// --------------------------------
// Apply
// --------------------------------
const applyContainers = document.querySelectorAll('[data-module="apply"]')

if (applyContainers.length > 0) {
	import('./components/apply')
			.then(({ apply }) => {
				applyContainers.forEach(container => {
					apply(container)
				})
			})
}

// --------------------------------
// Scroll to a target (with smooth scroll)
// --------------------------------
// const scrollToTriggers = document.querySelectorAll('[data-module="scroll-to"]')
//
// if (scrollToTriggers.length > 0) {
//   import('./components/scroll-to')
//     .then(({ scrollTo }) => {
// 			scrollToTriggers.forEach(trigger => {
// 				scrollTo(trigger)
// 			})
// 		})
// }

// --------------------------------
// Video
// --------------------------------
const videos = document.querySelectorAll('[data-module="video"]')

if (videos.length > 0) {
	import('./components/video-observer')
			.then(({ videoObserver }) => {
				videos.forEach(element => {
					videoObserver(element)
				})
			})
}

// --------------------------------
// Auto play videos when they are in the viewport
// --------------------------------
const autoPLayVideos = document.querySelectorAll('[data-module="autoplay-video"]')

if (autoPLayVideos.length > 0) {
	import('./components/video-autoplay')
			.then(({ videoAutoplay }) => {
				autoPLayVideos.forEach(video => {
					videoAutoplay(video)
				})
			})
}